import React from 'react'
import dndItemTypes from '../../../constants/dndItemTypes'
import DropTargetWrapperContainer from '../../../containers/dnd/DropTargetWrapperContainer';
import SortableWrapperContainer from '../../../containers/dnd/SortableWrapperContainer';
import { WEEKPROGRAMFLYER } from '../../../constants/printType';
import { MOVIE } from '../../../constants/itemTypes';
import ListItemMovieContainer from '../../DragAndDropItems/cont/ListItemMovieContainer';


const PrintWeekProgramFlyerChoosenMoviesList = ({
    weekProgramFlyerData,
    displayDropzones,
    addWeekProgramFlyerItem,
    reorderWeekProgramFlyerItems,
    deleteWeekProgramFlyerItem,
    relevantMovies,
    basicUrl
}) => {
    if(!weekProgramFlyerData) {
        return ''
    }

    return (
        <div className="periode-list">
            {displayDropzones ? (
                <ul>
                    <li className="periode-item-container">
                        <DropTargetWrapperContainer
                            listID={WEEKPROGRAMFLYER}
                            items={weekProgramFlyerData.choosenMovies.items}
                            selectionType={WEEKPROGRAMFLYER}
                            pushItem={addWeekProgramFlyerItem}
                            dndType={dndItemTypes.WEEK_PROGRAM_FLYER_ITEM_AD}
                        > 
                            <div className="periode-item-dropbox">
                                <div className="periode-item-dropbox-inner"></div>
                            </div>
                        </DropTargetWrapperContainer>
                    </li>
                </ul>
            ) : (
                <ul>
                    <li className="periode-item-container">
                        <div className="item-drag-container">
                            <ul className={'grid-container'}>
                                {weekProgramFlyerData.choosenMovies.order.map((itemId, index) => (
                                    <li key={index} className={"item-drag"}>
                                        <SortableWrapperContainer
                                            index={index} 
                                            moveItem={reorderWeekProgramFlyerItems}
                                            dndType={dndItemTypes.PROGRAM_ITEM_SORT}
                                        >
                                            <ListItemMovieContainer
                                                itemData={relevantMovies[itemId]}
                                                pathnameEdit={`${basicUrl}/${MOVIE}/${itemId}`}
                                                onDelete={() => deleteWeekProgramFlyerItem(itemId)}
                                            />
                                        </SortableWrapperContainer>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                </ul>
            )}
        </div>
    )
}

export default PrintWeekProgramFlyerChoosenMoviesList

